import { AlertTriangleIcon, Clock3Icon } from 'lucide-react'

import { useTheme } from 'styled-components'

export const useSectionPalette = () => {
  const theme = useTheme()

  const overdueAccent = theme.colors.red700
  const overdueBackground = theme.colors.red12
  const overdueBorder = theme.colors.red11

  const expiringAccent = `color-mix(in srgb, ${theme.colors.orange} 50%, black)`
  const expiringBackground = `color-mix(in srgb, ${theme.colors.orange} 10%, white)`
  const expiringBorder = `color-mix(in srgb, ${theme.colors.orange} 45%, white)`
  const expiringBadge = `color-mix(in srgb, ${theme.colors.orange} 45%, white)`

  return {
    overdue: {
      icon: (
        <AlertTriangleIcon
          className="size-4 shrink-0"
          style={{ color: overdueAccent }}
        />
      ),
      style: {
        backgroundColor: overdueBackground,
        borderColor: overdueBorder,
      },
      headerStyle: { backgroundColor: overdueBackground },
      titleStyle: { color: overdueAccent },
      badgeStyle: {
        backgroundColor: overdueBorder,
        color: overdueAccent,
      },
      chevronStyle: { color: overdueAccent },
      metaStyle: { color: overdueAccent },
    },
    expiringSoon: {
      icon: (
        <Clock3Icon
          className="size-4 shrink-0"
          style={{ color: expiringAccent }}
        />
      ),

      style: {
        backgroundColor: expiringBackground,
        borderColor: expiringBorder,
      },
      headerStyle: { backgroundColor: expiringBackground },
      titleStyle: { color: expiringAccent },
      badgeStyle: {
        backgroundColor: expiringBadge,
        color: expiringAccent,
      },
      chevronStyle: { color: expiringAccent },
      metaStyle: { color: expiringAccent },
    },
  }
}
